import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StoreService } from '../store.service';
import { ApiBaseService } from './api-base.service';
import ApiOptionsConfig from './api-options.config';

@Injectable({
  providedIn:'root'
})
export class DepartmentService extends ApiBaseService {

  list(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl('/departments'), options?.params);
  }

}